import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/cleaners`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/cleaners/${id}`);
  },
  async findAll() {
    return axios.get('/cleaners');
  },
  async search(payload) {
    let url = `/cleaners/search?search=${payload.searchString}`
    return axios.get(url);
  },
  async findAllByStatus() {
    return axios.get(`/cleaners`);
  },
  async delete({ id }) {
    return axios.delete(`/cleaners/${id}`);
  },
  async update(formData) {
    return axios.put(`/cleaners/${formData.id}`, formData);
  }
};
